/**
 * Session Guard - Global fetch interceptor for expired sessions.
 *
 * Wraps window.fetch to detect 401 responses from API endpoints.
 * When a 401 is detected, the user is shown a message and redirected
 * to the login page instead of seeing cryptic "HTTP error" alerts.
 *
 * Must be loaded before any application JS that makes fetch() calls.
 */
(function () {
    var isRedirecting = false;
    var originalFetch = window.fetch;

    window.fetch = function (url, options) {
        return originalFetch.apply(this, arguments).then(function (response) {
            if (
                response.status === 401 &&
                !isRedirecting &&
                typeof url === 'string' &&
                url.indexOf('/Api/') !== -1
            ) {
                isRedirecting = true;

                // Use the toast system if available, otherwise alert
                if (typeof showToast === 'function') {
                    showToast({
                        title: 'Session Expired',
                        message: 'Your session has expired. Redirecting to login...',
                        type: 'warning',
                        delay: 5000
                    });
                }

                setTimeout(function () {
                    window.location.href = '/landing';
                }, 1500);
            }
            return response;
        });
    };
})();